import {
  Paragraph,
  Table,
  TableRow,
  TableCell,
  TextRun,
  WidthType,
  AlignmentType,
  ShadingType,
} from "docx";

const horizontalBorders = {
  top: { style: "single", size: 1, color: "000000" },
  bottom: { style: "single", size: 1, color: "000000" },
  left: { style: "nil", size: 0, color: "FFFFFF" }, // heq border vertikal majtas
  right: { style: "nil", size: 0, color: "FFFFFF" }, // heq border vertikal djathtas
  insideHorizontal: { style: "single", size: 1, color: "000000" },
  insideVertical: { style: "nil", size: 0, color: "FFFFFF" }, // heq border vertikal të brendshëm
};

const cellText = (text, opts = {}) =>
  new TextRun({
    text,
    bold: opts.bold || false,
    color: opts.color || "000000",
    size: opts.size || 20,
  });

const para = (children, align = AlignmentType.LEFT) =>
  new Paragraph({ children, alignment: align });

const headerTVCell = (text) =>
  new TableCell({
    children: [
      para([cellText(text, { color: "FFFFFF" })], AlignmentType.CENTER),
    ],
    columnSpan: 3,
    shading: {
      type: ShadingType.CLEAR,
      fill: "ED1D25",
      color: "auto",
    },
    margins: {
      top: 30,
      bottom: 30,
      left: 40,
      right: 40,
    },
    borders: horizontalBorders,
  });

const simpleHeaderCell = (text) =>
  new TableCell({
    children: [para([cellText(text)], AlignmentType.CENTER)],
    borders: horizontalBorders,
    margins: {
      top: 30,
      bottom: 30,
      left: 40,
      right: 40,
    },
  });

const basicCell = (text, align = AlignmentType.LEFT) =>
  new TableCell({
    children: [para([cellText(text)], align)],
    borders: horizontalBorders,
    margins: {
      top: 30,
      bottom: 30,
      left: 40,
      right: 40,
    },
  });

const createTopTable = (tvLeft, tvRight, left, right) => {
  const maxRows = Math.max(left.length, right.length);

  const rows = [
    // Header i parë (TV emrat)
    new TableRow({
      children: [headerTVCell(tvLeft), headerTVCell(tvRight)],
    }),
    // Header i dytë
    new TableRow({
      children: [
        simpleHeaderCell("Nr"),
        simpleHeaderCell("Subjekti"),
        simpleHeaderCell("Koha/min"),
        simpleHeaderCell("Subjekti"),
        simpleHeaderCell("Koha/min"),
      ],
    }),
    // Rreshtat e të dhënave
    ...Array.from({ length: maxRows }).map(
      (_, i) =>
        new TableRow({
          children: [
            basicCell(`${i + 1}`, AlignmentType.CENTER),
            basicCell(left[i]?.[0] || ""),
            basicCell(left[i]?.[1]?.toFixed(2) || "", AlignmentType.CENTER),
            basicCell(right[i]?.[0] || ""),
            basicCell(right[i]?.[1]?.toFixed(2) || "", AlignmentType.CENTER),
          ],
        })
    ),
  ];

  return new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: horizontalBorders,
    rows,
  });
};

export const ModelWorldReklamaBleresit = (tableContent) => {
  const monthOrder = [
    "Janar",
    "Shkurt",
    "Mars",
    "Prill",
    "Maj",
    "Qershor",
    "Korrik",
    "Gusht",
    "Shtator",
    "Tetor",
    "Nëntor",
    "Dhjetor",
  ];

  const getTop5ByTV = (data, tv) => {
    const grouped = data
      .filter((d) => d.TV.trim() === tv)
      .reduce((acc, curr) => {
        const k = curr.Subjekti;
        const min = parseFloat(curr["Koha / min"]);
        acc[k] = (acc[k] || 0) + min;
        return acc;
      }, {});
    return Object.entries(grouped)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5);
  };

  const sortedEntries = Object.entries(tableContent).sort(
    ([a], [b]) => monthOrder.indexOf(a) - monthOrder.indexOf(b)
  );

  const docContent = [];

  for (const [muaji, data] of sortedEntries) {
    const left1 = getTop5ByTV(data, "RTSH 1");
    const right1 = getTop5ByTV(data, "Top Channel");
    const left2 = getTop5ByTV(data, "Klan");
    const right2 = getTop5ByTV(data, "Vizion Plus");

    docContent.push(
      new Paragraph({
        children: [
          new TextRun({
            text: muaji,

            color: "ED1D25",
            size: 28,
          }),
        ],
        spacing: { after: 200 },
      }),
      createTopTable("RTSH 1", "Top Channel", left1, right1),
      new Paragraph({ text: "" }),
      createTopTable("Klan", "Vizion Plus", left2, right2),
      new Paragraph({ text: "" })
    );
  }

  return docContent;
};
